import actions from './actions'
import mutations from './mutations'

const systemNotifications = {
    namespaced: true,
    state: {
        notifications: [],
        notificationsHistory: [],
        isLoaded: true,
        pagination: {
            length: null,
            page: 1
        },
        filters: {
            types: [],
            fromDate: null,
            toDate: null
        }
    },
    mutations,
    actions
}

export default systemNotifications
